import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";

const INITIAL_STATE = { firstname: null, lastname: null, token: null};

const loginReducer = createSlice({
    name: "Login",
    initialState: INITIAL_STATE,
    reducers: {
        onLogin(state, action) {
            state.firstname = action.payload.first_name;
            state.lastname = action.payload.last_name;
            state.token = action.payload.user_token;
        },
        onLogout(state) {
            storage.removeItem('persist:root');
            state.firstname = null;
            state.lastname = null;
            state.token = null;
        }
    }
});

export const loginReducerAction = loginReducer.actions;

export default loginReducer.reducer;